import { IId } from "client/resources";
import { keyBy } from "lodash";

export const toResourceLookup = <T extends IId>(items: ArrayLike<T>) => keyBy(items, (x) => x.Id);

export default toResourceLookup;
